<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный аккаунт {{currentClick2moneyAccount.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteClick2moneyAccount">Удалить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionClick2moneyAccountModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.GET_CLICK2MONEY_ACCOUNT_DETAILS_MODAL_CONFIRM_DELETION;
      },
      set(){
        this.$store.commit('SET_CONFIRM_DELETION_CLICK2MONEY_ACCOUNT_MODAL', false);
      }
    },
    isLoading: {
      get(){
        return this.$store.getters.GET_CLICK2MONEY_ACCOUNT_DETAILS_MODAL_CONFIRM_DELETION_LOADING;
      },
      set(value){
        this.$store.commit('SET_CONFIRM_DELETION_CLICK2MONEY_ACCOUNT_MODAL_LOADING', value);
      }
    },
    currentClick2moneyAccount: {
      get(){
        return this.$store.getters.GET_CURRENT_CLICK2MONEY_ACCOUNT;
      },
      set(value){
        this.$store.commit("SET_CURRENT_CLICK2MONEY_ACCOUNT", value);
      }
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentClick2moneyAccount = {};
      this.isLoading = false;
      this.isOpen = false;
    },
    deleteClick2moneyAccount(){
      this.$store.dispatch('DELETE_CLICK2MONEY_ACCOUNT', this.currentClick2moneyAccount.id)
        .then(() => {
          this.$toast.success('Click2Money аккаунт был удалён');
          this.close();
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });
    }
  },
};
</script>
